import React from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { Icon } from "rhombus-react";

import "./VersionImportPreviewGrowl.css";

export default function VersionImportPreviewGrowl({
	filename,
	libraryId,
	jobId,
}){
	const dispatch = useDispatch();
	const url = `/library/${libraryId}/modal/preview-version-import/${jobId}/`;

	function openPreview(e){
		e.preventDefault();

		// We can dispatch a push because Notification and the main app share a store, but not a router.
		dispatch(push(url));
	}

	return (
		<div className="version-import-preview-growl">
			<div className="description">
				<span className="name-overflow">
					{`Import of "${filename}"`}
				</span>
				is ready to preview
			</div>
			<div>
				{/*
					We can't use a <Link> here, because growls are outside the scope of the router,
					and we don't want to just use the href on the <a/> because it will reload the whole
					app instead of routing within it.
				*/}
				<a href="#" onClick={openPreview}>
					<Icon name="preview" />
					Preview Import
				</a>
			</div>
		</div>
	);
}
